import type {ThreadStatus} from 'nutshell-graphql-types';

import {Stack} from '../../layout/stack/stack';
import {LoadingText} from '../../loading-placeholder/loading-text';
import {Body} from '../../typography/body';

import {
    getCanArchiveFromTextable,
    getCanReopenFromTextable,
    getIsBlockedFromSelectedTextable,
    getRecipientFromSelectedTextable,
} from '../helpers';
import {TextableSelect} from '../textable-select/textable-select';
import {ThreadHeader} from '../thread-header/thread-header';
import type {Textable, UpdateAction} from '../types';

import styles from './sidebar-header.module.css';

interface Props {
    textables: Textable[];
    isLoading: boolean;
    selectedTextable: Textable | null | undefined;
    onSelectTextable: (textable: Textable) => void;
    onUpdateStatus: (action: UpdateAction) => Promise<any> | null | undefined;
    status: ThreadStatus | null | undefined;
    assigneeButton: React.ReactNode | null | undefined;
    openedFromEntityId: string;
}

export function SmsSidebarHeader(props: Props) {
    const isLoading = props.isLoading;
    const noValidRecipients = !isLoading && props.textables.length === 0;
    const multipleRecipients = !isLoading && props.textables.length > 1;

    return (
        <div className={styles.header}>
            {isLoading && (
                <div className='pad-16 flex flex-dir-col'>
                    <Stack spacing={4}>
                        <LoadingText width={140} />
                        <LoadingText width={100} />
                    </Stack>
                </div>
            )}
            {noValidRecipients && (
                <div className='pad-16 full-width'>
                    <Body as='div' size='small'>
                        No recipients found
                    </Body>
                </div>
            )}
            <ThreadHeader
                recipient={
                    props.selectedTextable && props.textables.length === 1
                        ? getRecipientFromSelectedTextable(props.selectedTextable)
                        : undefined
                }
                selectRecipientComponent={
                    multipleRecipients && (
                        <TextableSelect
                            selectedTextable={props.selectedTextable}
                            textables={props.textables}
                            onSelectTextable={props.onSelectTextable}
                            openedFromEntityId={props.openedFromEntityId}
                        />
                    )
                }
                canReopen={getCanReopenFromTextable(props.selectedTextable)}
                canArchive={getCanArchiveFromTextable(props.selectedTextable)}
                assigneeButton={props.assigneeButton}
                onUpdateStatus={props.onUpdateStatus}
                status={props.status}
                isSmall={true}
                isBlocked={
                    props.selectedTextable
                        ? getIsBlockedFromSelectedTextable(props.selectedTextable)
                        : undefined
                }
                openedFromEntityId={props.openedFromEntityId}
            />
        </div>
    );
}
